import React, { useCallback, useEffect, useState } from "react";
import { Accordion, Col, Row, Alert } from "react-bootstrap";
import { LoaderIcon } from "../Components/Global/Icons";
import { FadeAccordion, FadeAccordionItem } from "../Components/Global/Transitions";
import Messaging from "../Components/Global/Messaging/Messaging";
import { GetConversations } from "../Services/PtaasApiService";
import { useMsal } from "@azure/msal-react";
import Conversations from "../Models/Conversations";

const MessagingPage: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [fetchError, setFetchError] = useState<string | null>(null);
  const[conversations,setConversations]=useState<Conversations[]>([]);
  const { instance, accounts } = useMsal();

  const fetchConversations = useCallback( async (): Promise<void> => {
    try {
      setLoading(true);
      const returnconversation = await GetConversations(instance, accounts[0]);
      setConversations(returnconversation);
    } catch (error) {
      setFetchError("Failed to fetch messages. Please try again later.");
    } finally {
      setLoading(false);
    }
  },[instance, accounts]);

  useEffect(() => {
    fetchConversations();
  }, [fetchConversations]);

  // Callback to set unreadMessagesCount to 0 for a conversation
  const handleUnreadCountUpdate = useCallback((convId: string) => {
    setConversations(prev => prev.map(c =>
      c.id === convId ? { ...c, UnreadMessagesCount: 0, unreadMessagesCount: 0 } : c
    ));
  }, []);

  if (loading) {
    return <LoaderIcon />;
  }

  // Sort conversations: unread first, then latest message/createdAT
  const sortedConversations = conversations.slice().sort((a, b) => {
    const unreadA = a.UnreadMessagesCount || 0;
    const unreadB = b.UnreadMessagesCount || 0;
    if (unreadA !== unreadB) {
      return unreadB - unreadA;
    }
    const dateA = new Date( a.createdAT).getTime();
    const dateB = new Date( b.createdAT).getTime();
    return dateB - dateA;
  });

  return (
    <Row>
      <Col sm={12} as="h1">
        Messaging
      </Col>
      <Col sm={12}>
        {fetchError ? (
          <Alert variant="warning" onClose={() => setFetchError(null)} dismissible>
            {fetchError}
          </Alert>
        ) : (
          <FadeAccordion defaultActiveKey="0">
            <FadeAccordionItem eventKey="0" className="overflow-hidden position-relative">
              <Accordion.Body className="gradient p-0 m-0">
                <Messaging
                  conversations={sortedConversations}
                  onChange={fetchConversations}
                  onUnreadCountUpdate={handleUnreadCountUpdate}
                />
              </Accordion.Body>
            </FadeAccordionItem>
          </FadeAccordion>
        )}
      </Col>
    </Row>
  );
};

export default MessagingPage;
